import React from 'react';
import {Card, CardText} from 'material-ui/Card';
import {ViewTitle} from 'admin-on-rest/lib/mui';
import Avatar from 'material-ui/Avatar';
import HelpIcon from 'material-ui/svg-icons/action/report-problem';

export default () => {

    const NoAccessTitle = <span className="list-title hide-print">
            <Avatar icon={<HelpIcon/>} className="avatar-title system"/>No Access</span>;

    return (
        <div className="lists-container">
            <Card>
                <ViewTitle title={NoAccessTitle}/>
                <CardText>
                    Sorry, you do not have permission to access this page.
                </CardText>
            </Card>
        </div>
    )
};



// WEBPACK FOOTER //
// ./src/Fuse/noAccess.js